import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sidenav-header',
  templateUrl: './sidenav-header.component.html',
  styleUrls: ['./sidenav-header.component.scss'],
})
export class SidenavHeaderComponent {
  @Input() logoUrl: string =
    'https://s3-sa-east-1.amazonaws.com/antecipagov.public.docs/images/BROADFACTOR_MARCA_FUNDOCINZA_40%20(1).png';
  @Input() logoAlt: string = 'logo broadfactor';
  @Input() logoWidth: number = 130;
  @Input() logoHeight: number = 21;
}
